import {ValueListener} from "./interfaces";
import { EventSource } from "../eventSite/eventSource";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';

const compute = (rsvpQuestionOverrides) => {
    if (!rsvpQuestionOverrides) {
        return true;
    }

    // if the attending rsvp is on, options.rsvp will be undefined.
    // if the attending rsvp is off, that's an override, and options.rsvp will be false.
    // options.rsvp will never be true.
    return (rsvpQuestionOverrides.rsvp !== false);
}

export const observeAskingAttendingRsvpQuestion = (eventDataSource: any, listener: ValueListener<boolean>) => {

    listener = eventDataSource.wrapListener(listener);
    let rsvpQuestionOverrides;

    const onUpdate = function () {
        listener.onValue(compute(rsvpQuestionOverrides));
    };
    eventDataSource.observeRsvpQuestionOverrides({onValue: function (overrides) {
        rsvpQuestionOverrides = overrides;
        onUpdate();
    }});
};

export const observeAskingAttendingRsvpQuestion$ = (eventSource: EventSource): Observable<boolean> => {
    return eventSource.rsvpOverrides().map(rsvpQuestionOverrides => compute(rsvpQuestionOverrides))
};